export default __webpack_public_path__ + "static/media/group_4456.35e405b9.png";